module.exports = __webpack_public_path__ + "static/img/ent-63.56dcb15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-63.jpg
// module id = 8rqk
// module chunks = 51